import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { CategoryHero } from "@/components/CategoryHero";
import { ProductGrid } from "@/components/ProductGrid";
import { useCollectionProducts } from "@/lib/use-catalog";
import { newArrivals, lookProducts, accessories } from "@/lib/catalog";
const sacsAsset = { url: "/img/sacs.webp" };

export const Route = createFileRoute("/sacs")({
  head: () =>
    categoryHead({
      path: "/sacs",
      title: "Sacs & Paniers de Plage Femme | SUNSET",
      description:
        "Paniers tressés, cabas et sacs d'été choisis avec soin. Dès 379 DH, livraison partout au Maroc et paiement à la livraison.",
      socialDescription:
        "Paniers tressés et cabas d'été SUNSET Concept Store. Livraison partout au Maroc, paiement à la livraison.",
      name: "Sacs & Paniers",
      image: "/og/sacs.jpg",
      imageAlt: "Paniers et cabas d'été Sunset Concept Store",
      products: localProducts,
    }),
  component: SacsPage,
});

const localProducts = [...newArrivals, ...lookProducts, ...accessories].filter(
  (p) => p.category === "Sacs",
);

function SacsPage() {
  const products = useCollectionProducts("/sacs", localProducts, /sac|cabas|panier/i);
  return (
    <>
      <CategoryHero
        image={sacsAsset.url}
        imageAlt="Paniers et sacs d'été Sunset Concept Store"
        eyebrow="Collection"
        title="Sacs"
        subtitle="Paniers, cabas et pièces d'été choisis pour accompagner chaque escapade."
        imagePosition="sm:object-[50%_60%]"
      />
      <ProductGrid
        products={products}
        placeholderCount={8}
        title="Nos Sacs"
        eyebrow="Nouveautés"
        subtitle="Des accessoires pratiques et raffinés pour transporter l'essentiel."
        emptyMessage={
          <>
            <p className="text-sm text-muted-foreground sm:text-base">
              La collection Sacs sera bientôt disponible.
            </p>
            <p className="label-xs mt-3 text-accent">Revenez très vite</p>
          </>
        }
      />
    </>
  );
}
